import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import "./App.css";
import routes from "./routes";
import AuthProvider from "./hooks/AuthProvider";
import PrivatePage from "./pages/PrivatePage";
import ProfilePage from "./pages/ProfilePage";
import TagPage from "./pages/TagPage";
import SellerPage from "./pages/SellerPage";
import ShowPage from "./pages/ShowPage";
import SearchPage from "./pages/SearchPage";

function App() {
	return (
		<Router>
			<AuthProvider>
				<Routes>
					<Route path={routes.login} element={<LoginPage />} />
					<Route element={<PrivatePage />}>
						<Route path={routes.home} element={<HomePage />} />
					</Route>
					<Route element={<PrivatePage />}>
						<Route path={routes.profile} element={<ProfilePage />} />
					</Route>
					<Route element={<PrivatePage />}>
						<Route path={routes.tag} element={<TagPage />} />
					</Route>
					<Route element={<PrivatePage />}>
						<Route path={routes.seller} element={<SellerPage />} />
					</Route>
					<Route element={<PrivatePage />}>
						<Route path={routes.show} element={<ShowPage />} />
					</Route>
					<Route element={<PrivatePage />}>
						<Route path={routes.search} element={<SearchPage />} />
					</Route>
				</Routes>
			</AuthProvider>
		</Router>
	);
}

export default App;
